<version-breadcrumb-header
  [version]="version"
  [title]="bcTitle"
  [menu]="status == STATUS_NOT_ACCESS_DONE ? [] : menu"
  (action)="onMenuClick($event)"
  (statusAction)="onStatusUpdate($event)"
  (setLabels)="onSetLabels($event)"
></version-breadcrumb-header>
<div class="loader">
  <div class="dimmed" [hidden]="status != STATUS_LOADING">
      <div class="dimmed_flex">
          <div class="dimmed_versions dimmed_content">
              <div class="dimmed_title"></div>
              <div class="dimmed_subtitle"></div>
              <div class="dimmed_subtitle"></div>
          </div>
          <div class="dimmed_status"></div>
      </div>
  </div>
</div>
<div *ngIf="status == STATUS_DONE" class="version" [ngClass]="{'with-overlay': view != VIEW_APPROVAL_REMINDER_NONE}">
    <core-layout-modal-feedback class="modal-feedback modal-reminder-success" *ngIf="view == VIEW_APPROVAL_REMINDER_DONE"
      [type]="'done'"
      [message]="'Approval reminder sent'"
      [buttonText]="'Done'"
      (action)="onReminderSent($event)">
    </core-layout-modal-feedback>
    <core-layout-modal-feedback class="modal-feedback modal-reminder-error" *ngIf="view == VIEW_APPROVAL_REMINDER_ERROR"
      [type]="'fail'"
      [message]="'Error'"
      [text]="'Something went wrong. Please try again. If the error persists, please reach out to our support team through the <strong>Help Me button</strong>.'"
      [buttonText]="'Go back'"
      (action)="onReminderSent($event)">
    </core-layout-modal-feedback>
    <!-- we need the project for links to plugins, in the case -->
    <version-details-content [project]="project"></version-details-content>
</div>
<div class="version-details-forbidden"  *ngIf="status == STATUS_NOT_ACCESS_DONE && version != null">
  <core-versions-detail-box
      [version]="version"
  ></core-versions-detail-box>
  <core-helpers-box-alert-message-icon
    [text]="'You don’t have permission to see this artwork'"
    [icon]="'alert'"
  ></core-helpers-box-alert-message-icon>
</div>
<!-- <core-helpers-box-http-error
    *ngIf="status == STATUS_NOT_ACCESS_DONE"
    [code]="403"
    [message]="'Not allowed.'"
></core-helpers-box-http-error> -->

<core-helpers-box-http-error
    *ngIf="status == STATUS_NOT_FOUND"
    [code]="404"
    [message]="'Not found.'"
></core-helpers-box-http-error>

<core-helpers-box-http-error
    *ngIf="status == STATUS_ERROR"
    [code]="500"
    [message]="'Error. Check your url'"
></core-helpers-box-http-error>
